(function() { window.GUID_8a56c7f6_b8dc_4ebc_a01f_a03fc0ea1546 = { getGuid: function() { return "8a56c7f6-b8dc-4ebc-a01f-a03fc0ea1546"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-winrateagainsteachother",
                        callback: (accordion, e) => {
                            var _a;
                            const $tabmenu = accordion.$Container.find(".tabmenu.control-cs:not(.winrate-against-each-other-tabmenu)");
                            accordion.SetContentSticky($tabmenu);
                            const $emptyStateElement = accordion.$Content.find(`#WinRateAgainstEachOtherSectionViewModelNoData-${accordion.ContentId}`);
                            if ($emptyStateElement.length) {
                                const $gameTypeNameInput = accordion.$Content.find(`#WinRateAgainstEachOtherSectionViewModelGameTypeName-${accordion.ContentId}`);
                                const gameTypeName = (_a = $gameTypeNameInput.val()) !== null && _a !== void 0 ? _a : "";
                                if (gameTypeName.trim() === "") {
                                    $emptyStateElement.text(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOther);
                                }
                                else {
                                    $emptyStateElement.html(CS.Helper.formatString(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOtherInX, gameTypeName));
                                }
                                return;
                            }
                            let timePeriod = accordion.$Container
                                .find(`#WinRateAgainstEachOtherCurrentTimePeriod-${accordion.ContentId}`)
                                .val();
                            const $dataInput = accordion.$Container.find(`#WinRateAgainstEachOtherSectionViewModelData-${accordion.ContentId}`);
                            const anyData = $dataInput.length > 0 && $dataInput.val() != null;
                            if (!anyData)
                                return;
                            const data = JSON.parse($dataInput.val());
                            const canvas = document.getElementById(`WinRateAgainstEachOtherCanvas-${accordion.ContentId}`);
                            if (!canvas)
                                return;
                            const context = canvas.getContext("2d");
                            let chart = null;
                            const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                            const labels = [];
                            let datasetsMeta = [];
                            const isMobile = CS.CommonData.Current.IsMobileDevice;
                            const $canvasContainer = $(canvas).parent();
                            $canvasContainer.css({
                                "max-width": isMobile ? "300px" : "400px",
                                margin: "0 auto",
                                overflow: "hidden",
                            });
                            const $personaContainer1 = accordion.$Container.find(`.persona-container[data-dataset-index="${1}"]`);
                            $personaContainer1.css({
                                "box-shadow": `inset 0 0 100vw 100vw ${colors[0]}20`,
                                border: `1px solid ${colors[0]}50`,
                            });
                            const $picHelper1 = $personaContainer1.find(".pic-helper");
                            $picHelper1.css({
                                outline: `1px solid ${colors[0]}`,
                            });
                            const $personaContainer2 = accordion.$Container.find(`.persona-container[data-dataset-index="${2}"]`);
                            $personaContainer2.css({
                                "box-shadow": `inset 0 0 100vw 100vw ${colors[1]}20`,
                                border: `1px solid ${colors[1]}50`,
                            });
                            const $picHelper2 = $personaContainer2.find(".pic-helper");
                            $picHelper2.css({
                                outline: `1px solid ${colors[1]}`,
                            });
                            const allTimeData = {
                                labels: [
                                    data.AllTime.Persona1.Persona.PersonaName,
                                    "",
                                    data.AllTime.Persona2.Persona.PersonaName,
                                ],
                                datasets: [
                                    {
                                        label: `${data.AllTime.Persona1.Persona.PersonaName},${data.AllTime.Persona2.Persona.PersonaName}`,
                                        data: [
                                            data.AllTime.Persona1.WinsPercent.toFixed(2),
                                            0.5,
                                            data.AllTime.Persona2.WinsPercent.toFixed(2),
                                        ],
                                        backgroundColor: [colors[0], "white", colors[1]],
                                        extraData: {
                                            persona1Wins: data.AllTime.Persona1.Wins,
                                            persona1PlayedGames: data.AllTime.Persona1.PlayedGames,
                                            persona2Wins: data.AllTime.Persona2.Wins,
                                            persona2PlayedGames: data.AllTime.Persona2.PlayedGames,
                                        },
                                    },
                                ],
                            };
                            const lastYearData = {
                                labels: [
                                    data.LastYear.Persona1.Persona.PersonaName,
                                    "",
                                    data.LastYear.Persona2.Persona.PersonaName,
                                ],
                                datasets: [
                                    {
                                        label: `${data.LastYear.Persona1.Persona.PersonaName},${data.LastYear.Persona2.Persona.PersonaName}`,
                                        data: [
                                            data.LastYear.Persona1.WinsPercent.toFixed(2),
                                            0.5,
                                            data.LastYear.Persona2.WinsPercent.toFixed(2),
                                        ],
                                        backgroundColor: [
                                            colors[0],
                                            data.LastYear.Persona1.PlayedGames == 0
                                                ? "rgba(255,255,255,0.1)"
                                                : "white",
                                            colors[1],
                                        ],
                                        extraData: {
                                            persona1Wins: data.LastYear.Persona1.Wins,
                                            persona1PlayedGames: data.LastYear.Persona1.PlayedGames,
                                            persona2Wins: data.LastYear.Persona2.Wins,
                                            persona2PlayedGames: data.LastYear.Persona2.PlayedGames,
                                        },
                                    },
                                ],
                            };
                            const updateWinnerDisplay = (timePeriod) => {
                                const data = timePeriod === "all" ? allTimeData : lastYearData;
                                const persona1WinsPercent = data.datasets[0].data[0];
                                const persona2WinsPercent = data.datasets[0].data[2];
                                const { persona1Wins, persona1PlayedGames, persona2PlayedGames, persona2Wins, } = data.datasets[0].extraData;
                                let $winnerContainer = accordion.$Container.find(`.winrate-against-each-other-winner-container-${accordion.ContentId}`);
                                if (!$winnerContainer.length) {
                                    $canvasContainer.append(`<div class="winrate-against-each-other-winner-container winrate-against-each-other-winner-container-${accordion.ContentId}"></div>`);
                                    $winnerContainer = accordion.$Container.find(`.winrate-against-each-other-winner-container-${accordion.ContentId}`);
                                }
                                if (persona1WinsPercent == persona2WinsPercent) {
                                    $winnerContainer.hide();
                                }
                                else if (persona1WinsPercent > persona2WinsPercent) {
                                    $winnerContainer.html(`<div class="winrate-against-each-other-winner__name" style="color: ${colors[0]};">${data.labels[0]}</div>

              <div class="winrate-against-each-other-winner__value" >${persona1WinsPercent}%</div>
              <div class="winrate-against-each-other-winner__count">${JSRess.Against.toLowerCase()} ${data.labels[2]} (${persona1Wins} / ${persona1PlayedGames})</div>`);
                                    $winnerContainer.show();
                                }
                                else {
                                    $winnerContainer.html(`<div class="winrate-against-each-other-winner__name" style="color: ${colors[1]};">${data.labels[2]}</div>

              <div class="winrate-against-each-other-winner__value">${persona2WinsPercent}%</div>
              <div class="winrate-against-each-other-winner__count">${JSRess.Against.toLowerCase()} ${data.labels[0]} (${persona2Wins} / ${persona2PlayedGames})</div>`);
                                    $winnerContainer.show();
                                }
                            };
                            updateWinnerDisplay(timePeriod);
                            const gaugeChartConfig = {
                                type: "doughnut",
                                data: timePeriod === "all"
                                    ? JSON.parse(JSON.stringify(allTimeData))
                                    : JSON.parse(JSON.stringify(lastYearData)),
                                plugins: [ChartDataLabels],
                                options: {
                                    responsive: true,
                                    rotation: 270,
                                    circumference: 180,
                                    cutout: "70%",
                                    showLines: false,
                                    borderColor: "rgba(255,255,255,0.1)",
                                    plugins: {
                                        legend: {
                                            display: false,
                                        },
                                        title: {
                                            display: false,
                                        },
                                        tooltip: false,
                                        datalabels: {
                                            color: "white",
                                            textShadowColor: "black",
                                            textShadowBlur: 5,
                                            formatter: function (value, context) {
                                                if (typeof value === "number")
                                                    return "";
                                                return `${value}%`;
                                            },
                                            font: {
                                                family: "Open Sans",
                                                style: "italic",
                                                weight: 600,
                                            },
                                        },
                                    },
                                    x: {
                                        display: false,
                                        stacked: false,
                                        grid: {
                                            color: "rgba(255, 255, 255, 0.25)",
                                            borderColor: "rgba(255, 255, 255, 0.1)",
                                        },
                                        ticks: {
                                            display: false,
                                            color: "rgba(255, 255, 255, 1)",
                                        },
                                    },
                                    y: {
                                        display: false,
                                        beginAtZero: false,
                                        max: null,
                                        ticks: {
                                            color: "rgba(255, 255, 255, 0.75)",
                                            callback: function (value, index, ticks) {
                                                return value + "%";
                                            },
                                        },
                                        grid: {
                                            color: "rgba(255, 255, 255, 0.1)",
                                            borderColor: "rgba(255, 255, 255, 0.15)",
                                        },
                                    },
                                },
                            };
                            chart = new Chart(canvas, gaugeChartConfig);
                            canvas.style.marginTop = "-20%";
                            canvas.style.marginBottom = "-20%";
                            accordion.$Control.offon(`click.${accordion.UniqueInstanceId}`, ".tabmenu.control-cs .tab-menu-item", (e) => {
                                const $item = $(e.currentTarget);
                                const timePeriod = $item.attr("id");
                                const isHighlighted = $item.hasClass("is-highlighted");
                                updateWinnerDisplay(timePeriod);
                                if (!isHighlighted) {
                                    $item.addClass("is-highlighted");
                                    $item.siblings().removeClass("is-highlighted");
                                    switch (timePeriod) {
                                        case "all":
                                            chart.data.datasets[0].data = JSON.parse(JSON.stringify(allTimeData.datasets[0].data));
                                            $personaContainer1
                                                .find(".games-played")
                                                .text(data.AllTime.Persona1.PlayedGames);
                                            $personaContainer1
                                                .find(".games-won")
                                                .text(data.AllTime.Persona1.Wins);
                                            $personaContainer2
                                                .find(".games-played")
                                                .text(data.AllTime.Persona2.PlayedGames);
                                            $personaContainer2
                                                .find(".games-won")
                                                .text(data.AllTime.Persona2.Wins);
                                            break;
                                        case "last-year":
                                            chart.data.datasets[0].data = JSON.parse(JSON.stringify(lastYearData.datasets[0].data));
                                            $personaContainer1
                                                .find(".games-played")
                                                .text(data.LastYear.Persona1.PlayedGames);
                                            $personaContainer1
                                                .find(".games-won")
                                                .text(data.LastYear.Persona1.Wins);
                                            $personaContainer2
                                                .find(".games-played")
                                                .text(data.LastYear.Persona2.PlayedGames);
                                            $personaContainer2
                                                .find(".games-won")
                                                .text(data.LastYear.Persona2.Wins);
                                            break;
                                        default:
                                    }
                                    chart.update();
                                }
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
